module.exports = __webpack_public_path__ + "img/girld.5e17eebe.png";